// Amount and unit are one field, not two: an amount without its unit is not a quantity, and
// splitting them across the form invites saving one without the other.

import ListSelect from './ListSelect.jsx';

export default function QuantityInput({
  amount, unit, units, onAmount, onUnit, error, onAdded, canAdd = false, flag = null,
}) {
  return (
    <fieldset className="quantity">
      <legend>Volume{flag}</legend>
      <label className="field">
        <span className="field-label">Amount</span>
        {/* inputMode rather than type=number: a spinner on a trade quantity is noise, and
            type=number silently discards what it cannot parse. The value stays a string all the
            way to the server, so the digits typed are the digits stored. */}
        <input inputMode="decimal" value={amount} onChange={(e) => onAmount(e.target.value)}
               placeholder="5000" />
      </label>
      <ListSelect label="Unit" listName="unit" entries={units} value={unit}
                  onChange={onUnit} error={error} onAdded={onAdded} canAdd={canAdd} />
    </fieldset>
  );
}
